import './layout-admin.scss';
import Dashboard from "./Dashboard/Dashboard";


const LayoutAdmin = () => {

    return (
        <div className={"adminLayout"}><Dashboard/></div>
    );
};

export default LayoutAdmin;

